import axios from "axios";

const CONFIGURED_API_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "sharda-stability-token";

/* Detect Capacitor native environment */
const isCapacitorNative = () => {
  if (typeof window === "undefined") return false;
  if (window.Capacitor?.isNativePlatform?.()) return true;
  if (window.Capacitor?.getPlatform?.() === 'android' || window.Capacitor?.getPlatform?.() === 'ios') return true;
  // Fallback: Capacitor serves from localhost with https scheme
  const origin = window.location.origin || '';
  if (origin.includes('localhost') && !origin.includes(':3000') && !origin.includes(':8001')) return true;
  if (window.location.protocol === 'capacitor:') return true;
  return false;
};

const isEmergentHost = (host) =>
  host.endsWith(".emergent.host") || host.endsWith(".preview.emergentagent.com");

const resolveApiUrl = () => {
  if (typeof window === "undefined") return CONFIGURED_API_URL;

  // In Capacitor native: ALWAYS use the build-time configured URL, no exceptions
  if (isCapacitorNative()) {
    return CONFIGURED_API_URL;
  }

  const currentOrigin = window.location.origin;
  if (!CONFIGURED_API_URL) return currentOrigin;

  try {
    const configuredUrl = new URL(CONFIGURED_API_URL);
    const currentUrl = new URL(currentOrigin);

    if (isEmergentHost(currentUrl.host) && configuredUrl.host !== currentUrl.host) {
      return currentOrigin;
    }

    if (!isEmergentHost(currentUrl.host)) {
      return currentOrigin;
    }

    return configuredUrl.origin;
  } catch {
    return CONFIGURED_API_URL;
  }
};

const API_URL = resolveApiUrl();

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export { api, API_URL, TOKEN_KEY };